import React, { useEffect, useState } from 'react'
import Banner from './Banner'
import './About.css'
import Footer from '../components/Footer'
import Gallery from './Gallery'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import SendIcon from '@mui/icons-material/Send';

const Refund = ({ galleryRef, contactRef }) => {
    const pageName = "Refund & Cancellation Policy"


    return (
        <>
            <Banner pageName={pageName} />
            <section className='abt_cont'>
                <div className='container'>
                    <article>
                        <div className='d-flex mb-6 mt-3 flex-column align-items-end'>
                            <p className="text-muted mb-1">Effective Date: 8 August 2026</p>
                            <p className="text-muted">Last Updated: 8 August 2026</p>
                        </div>

                        <h1 className="text-center mb-5 uppercase fw-bold w-100 mt-4" style={{color: "#5e79bc", lineHeight: "65px", textTransform: "uppercase", fontSize: "32px" }}> 
                            This Refund & Cancellation Policy applies to services provided by Car Genie, a brand operated by BM Enterprises
                            <br/> ("BM Enterprises", "we", "us", or "our"). 
                        </h1>

                        <h3 className="mb-5" style={{color: "#6d6c6c", lineHeight: "50px", fontWeight: 300}}>
                            Because automotive services involve vehicle inspection, labour, parts, consumables and services that may be customised for an individual vehicle, refunds and cancellations are subject to the terms below.
                        </h3>

                        <h3 style={{color: "#5e79bc"}}> <span>1.</span> Service Bookings </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3 w-100'>
                            Customers may request cancellation or rescheduling of a service appointment by contacting Car Genie as early as reasonably possible.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3 w-100'>
                            Where a booking has not yet resulted in any expenditure, procurement or commencement of work, we may permit cancellation without a cancellation charge.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3 w-100'>
                            However, if work has already commenced, parts or materials have been procured specifically for the customer's vehicle, or other costs have been incurred, the applicable amount may be deducted from any refundable amount.
                        </p>


                        <h3 className='mt-5 w-100' style={{color: "#5e79bc"}}> <span>2.</span> Advance Payments </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3'>
                            Where an advance payment is collected for a service:
                        </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mb-5 w-100'>
                            <li>•⁠  The advance may be adjusted against the final service invoice. </li>
                            <li>•⁠  ⁠If the customer cancels before any work or procurement has commenced, a refund may be considered subject to applicable payment processing charges, if any. </li>
                            <li>•⁠  ⁠If work has commenced or parts/materials have been purchased specifically for the vehicle, the refundable amount may be reduced accordingly. </li>
                            <li>•⁠  Certain special-order parts or customised services may be non-refundable once ordered or commenced. </li>
                        </ul>

                        <h3 style={{color: "#5e79bc"}}> <span>3.</span> Cancellation After Work Has Started </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Once vehicle repair, painting, detailing, replacement, installation or any other service has commenced, cancellation may not qualify for a full refund.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            The customer may be charged for:
                        </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mb-3'>
                            <li>•⁠  Labour already performed</li>
                            <li>•⁠  Parts and materials already purchased or consumed</li>
                            <li>•⁠  Diagnostic or inspection charges</li>
                            <li>•⁠  Third-party charges</li>
                            <li>•⁠  Other reasonable costs already incurred in connection with the service</li>
                        </ul>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> Any remaining eligible balance may be refunded or adjusted against other payable amounts, as applicable.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>4.</span> Parts and Components </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> 
                            Parts purchased specifically for a customer's vehicle are subject to the manufacturer's, distributor's or supplier's applicable return and warranty conditions.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            If a part cannot be returned or refunded by the supplier, Car Genie may not be able to provide a refund for that part.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Warranty claims relating to parts will be handled in accordance with the applicable manufacturer's or supplier's warranty terms.
                        </p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>5.</span> Vehicle Repair and Service Outcomes </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Automotive repair and restoration outcomes can depend on the condition, age, previous repairs, accident history and underlying condition of a vehicle
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Payment for a completed service does not automatically qualify for a refund merely because the customer is dissatisfied with an outcome where the agreed service has been performed.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Where a customer reports a service-related issue, Car Genie may inspect the vehicle and, where appropriate, provide a reasonable corrective solution in accordance with the applicable service or warranty terms.
                        </p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>6.</span> Denting, Painting, Detailing and Customised Services </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> 
                            Services such as denting, painting, polishing, ceramic coating, PPF and other customised work may involve materials and labour specifically allocated to the customer's vehicle.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Once such work has commenced, cancellation may not qualify for a full refund.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> Colour, finish and visual appearance may also be affected by the existing condition of the vehicle, previous repairs, age of paint and other factors.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>7.</span> Insurance-Related Services </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                           Where Car Genie assists a customer with an insurance claim, the approval, settlement amount, deductions, depreciation, exclusions and other claim-related decisions are determined by the relevant insurance company and/or authorised parties.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> Car Genie does not guarantee the approval or settlement of an insurance claim. </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> Refunds relating to insurance claim assistance, where applicable, will be governed by the specific service arrangement and amounts actually paid or incurred. </p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>8.</span> Refund Processing </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>  Where a refund is approved, it will generally be processed using the original payment method, where technically possible.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> The time required for the amount to reflect in the customer's account may depend on the payment gateway, bank or financial institution.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> Any applicable transaction, gateway or third-party charges may be deducted where permitted.</p>


                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>9.</span> Non-Refundable Charges </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>The following may generally be non-refundable once incurred:</p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}}>
                            <li>•⁠  Diagnostic charges</li>
                            <li>•⁠  Inspection charges</li>
                            <li>•⁠  Labour already performed</li>
                            <li>•⁠  Parts already purchased or installed</li>
                            <li>•⁠  Consumables already used</li>
                            <li>•⁠  Special-order parts</li>
                            <li>•⁠  Third-party charges</li>
                            <li>•⁠  Services already completed</li>
                            <li>•⁠  Other expenses specifically incurred for the customer's vehicle</li>
                        </ul>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>10.</span> Incorrect or Duplicate Payments </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>If a customer has made a duplicate payment or an incorrect payment, the customer may contact us with the relevant transaction details.</p>
                        
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>After verification, the eligible amount may be refunded or adjusted against outstanding dues.</p>


                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>11.</span> Refund Requests </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>To request a refund, customers should contact:</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>BM Enterprises</b> <br/>
                            <b>Brand:</b> Car Genie
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Email:</b> <a href="mailto: care@cargenie.co.in "> care@cargenie.co.in </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Phone:</b> <a href="tel: +917003900368"> +91-7003900368  </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Address:</b> <address>1, RIC Bazar, Dunlop,
                                Bonhooghly Government Colony,
                                Kolkata, Baranagar
                                West Bengal 700108
                            </address>
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mt-3 mb-2'>
                            <b>Please provide:</b>
                        </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mt-3'>
                            <li>•⁠  Please provide</li>
                            <li>•⁠  Mobile number</li>
                            <li>•⁠  Vehicle registration number</li>
                            <li>•⁠  Invoice/booking number, if applicable</li>
                            <li>•⁠  ⁠Payment transaction details</li>
                            <li>•⁠  Reason for the refund request</li>
                        </ul>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mt-3 mb-2'>
                            We may request additional information to verify the transaction.
                        </p>
                        

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>12.</span> Policy Changes </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>BM Enterprises reserves the right to modify this Refund & Cancellation Policy from time to time.</p>
                        
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>The updated policy will be published on the Car Genie website with the revised "Last Updated" date.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>13.</span> Contact </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>For questions regarding cancellations, refunds or service-related concerns, please contact Car Genie using the contact details published on our website.</p>
                        
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Car Genie is a brand operated by BM Enterprises.</p>
                    </article>
                </div>
            </section>

        </>
    )
}

export default Refund